import * as React from 'react';

export type HandleCloseType = (event: React.MouseEvent<EventTarget>) => void;

export const HandleCloseContext = React.createContext<HandleCloseType | undefined>(undefined);

export function useHandleClose(): HandleCloseType | undefined {
    return React.useContext(HandleCloseContext);
}
